<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Cadastrar Membro Externo'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <div class="center">
                      <v-card outlined>
                        <v-card-text class="black--text font-weight-bold">
                          Cadastre o membro externo preenchendo os dados do formulário abaixo. Caso o membro externo necessite ter acesso aos sistemas corporativos da UFES ou ao
                          <a href="http://nti.ufes.br/eduroam" target="_blank">Eduroam</a>, o cadastro deve ser realizado por meio do sistema <a href="url" id="excadLink" target="_blank">ExCAD - Extensão do Cadastro</a>.
                          Para obter maiores informações sobre o sistema ExCAD, clique no link a seguir: <a href="http://www.sti.ufes.br/excad-extensao-de-cadastro-de-pessoas-sem-vinculo" target="_blank">STI - Serviços web - ExCAD</a>.
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-flex>
                </v-layout>

                <p class="mt-3"></p>

                <!-- O membro externo é estrangeiro? -->
                <v-layout row wrap justify-center>
                  <v-flex sm10 xs12>
                    <v-radio-group v-model="pessoa.estrangeiro" mandatory label="O membro externo é estrangeiro?"
                    >
                      <v-radio label="Sim" :value="true" ></v-radio>
                      <v-radio label="Não" :value="false" ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <!-- Nome -->
                <v-layout row wrap justify-center>
                  <v-flex sm10 xs12>
                    <v-text-field
                      label='Nome'
                      v-model="pessoa.nome"
                      required
                      :rules="assuntoSummaryRules255"
                      max-height="400">
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <!-- Nome social -->
                <v-layout row wrap justify-center v-if="pessoa.estrangeiro === false">
                  <v-flex sm10 xs12>
                    <v-checkbox v-model="temNomeSocial" label="Possui nome social?"></v-checkbox>
                  </v-flex>
                  <v-flex sm10 xs12>
                    <v-text-field v-if="temNomeSocial"
                      label='Nome Social'
                      v-model="pessoa.nomeSocial"
                      required
                      :rules="assuntoSummaryRules255"
                      max-height="400">
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <!-- CPF -->
                <v-layout row wrap justify-center v-if="pessoa.estrangeiro === false">
                  <v-flex sm10 xs12>
                    <v-text-field
                      label='CPF'
                      v-model="pessoa.cpf"
                      mask="###.###.###-##"
                      return-masked-value
                      required
                      :rules="cpfRules">
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <!-- Passaporte -->
                <v-layout row wrap justify-center v-if="pessoa.estrangeiro === true">
                  <v-flex sm10 xs12>
                    <v-text-field
                      label='Passaporte'
                      v-model="pessoa.passaporte"
                      required
                      :rules="passaporteRules">
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-center>
                  <!-- Sexo -->
                  <v-flex sm4 xs12>
                    <v-select
                      label='Sexo'
                      :items="listaSexo"
                      item-text="descricao"
                      item-value="item"
                      v-model="pessoa.sexo"
                      :rules="regrasBasicas" >
                    </v-select>
                  </v-flex>

                  <v-flex sm2 xs0>
                  </v-flex>

                  <!-- Data de nascimento -->
                  <v-flex sm4 xs12>
                    <v-text-field
                      label='Data de nascimento'
                      v-model="pessoa.dtNascimento"
                      required
                      type="date"
                      :rules="regrasBasicas">
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <p class="mt-3"></p>

              </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="criarPessoa(false)" :disabled="!formularioValido">Cadastrar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import DataMenu from '@/components/c-date-menu'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      formularioValido: false,
      temNomeSocial: false,
      listaSexo: [
        {descricao: 'Masculino', item: 'M'},
        {descricao: 'Feminino', item: 'F'}
      ],
      pessoa: {
        nome: '',
        nomeSocial: '',
        cpf: '',
        passaporte: '',
        estrangeiro: false
      },
      assuntoSummaryRules255: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => !!input && input.length <= 255 || 'Este campo não pode possuir mais que 255 caracteres'
      ],
      cpfRules: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      passaporteRules: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      excadServer: {}
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      cancelar: function () {
        this.$router.push({name: 'ParceriasProjeto', params: {idProjeto: this.idProjeto}})
      },
      criarPessoa: function (avancar) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Criando novo membro externo.' })

        if (!this.temNomeSocial || this.pessoa.estrangeiro === true) {
          this.pessoa.nomeSocial = this.pessoa.nome
        }

        projetos.postPessoa(this.pessoa)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          let link = response.body.link
          let idPessoa = link.split('/')[5]
          if (confirm('Deseja adicionar essa pessoa como integrante do projeto?')) {
            this.adicionarIntegrante(idPessoa)
          } else {
            this.$router.go(-1)
          }
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Criando novo membro externo.' })
        })
      },
      adicionarIntegrante (idPessoa) {
        console.log('Entrou aqui')
        // let hoje = new Date()
        // let dd = hoje.getDate()
        // let mm = hoje.getMonth() + 1
        // let yyyy = hoje.getFullYear()
        let data = this.projeto.dataInicio
        let integrante = {
          idPessoa: idPessoa,
          funcao: {item: 18, descricao: 'Integrante'},
          titulacao: {item: 99, descricao: 'Escolaridade/Titulação Indefinida'},
          cargaHoraria: 0,
          dataInicial: data,
          situacao: 'A'
        }
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando integrante...' })
        projetos.postIntegrante(this.$props.idProjeto, integrante)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: 'Integrante adicionado com sucesso!'})
          let listaLink = response.body.link.split('/')
          let idIntegranteAux = listaLink[listaLink.length - 1]
          this.$router.push({name: 'EditarIntegrante', params: {idProjeto: this.idProjeto, idParticipante: idIntegranteAux}})
        })
        .catch(error => {
          console.log('Erro ao mandar a requisição' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando integrante...' })
        })
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando endereço do servidor do ExCAD.' })
      projetos.getExcadServer()
      .then(response => {
        this.excadServer = response.data
        // Preenche o link com a URL do ExCAD.
        var excadServerUrl = this.excadServer.url
        document.getElementById('excadLink').setAttribute('href', excadServerUrl)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando endereço do servidor do ExCAD.' })
      })
    },

    components: {
      'basic-toolbar': BasicToolbar,
      'c-date-menu': DataMenu
    }
  }
</script>

<style lang="css">

  .center {
    text-align: center;
  }

  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }

  .input-group__icon-cb {
    cursor: pointer !important;
  }

</style>



// WEBPACK FOOTER //
// novo-membro-externo.vue?66371072